angular.module('billing').factory('BillingService',
    ['$rootScope', 'BillingRepository', '$q', 'PatientSettingsService',
        function ($rootScope, BillingRepository, $q, PatientSettingsService) {
            'use strict';

            var billingServiceUserId,
                accountBalance,
                billingAccount,
                statementHistory,
                viewMakeAPaymentFeature,
                viewLedgerFeature,
                viewStatementFeature,
                receiptHtml = {
                    TxId: '',
                    Result: ''
                };

            var featureList = PatientSettingsService.getPatientFeatures();
            viewMakeAPaymentFeature = featureList.MakeAPayment.IsActive;
            viewLedgerFeature = featureList.ViewPatientLedger.IsActive;
            viewStatementFeature = featureList.ViewPatientStatement.IsActive;

            function getViewMakeAPaymentFeatureFlag() {
                return viewMakeAPaymentFeature;
            }

            function getViewLedgerFeatureFlag() {
                return viewLedgerFeature;
            }

            function getViewStatementFeatureFlag() {
                return viewStatementFeature;
            }

            function getAccountBalance(userId) {
                //only used when MakeAPaymentFeatureFlag is disabled
                if (userId !== billingServiceUserId) {
                    resetBillingService();
                    setBillingServiceUserId(userId);
                }

                if (!accountBalance) {
                    return BillingRepository.getAccountBalance(userId)
                        .then(function (data) {
                            accountBalance = data;
                            return accountBalance;
                        });
                } else {
                    return $q.when(accountBalance);
                }
            }

            function getBillingAccount(requestDto) {
                if (requestDto.LoginUserPatientId !== billingServiceUserId) {
                    resetBillingService();
                    setBillingServiceUserId(requestDto.LoginUserPatientId);
                }

                if (!billingAccount) {
                    return BillingRepository.getBillingAccount(requestDto)
                        .then(function (data) {
                            billingAccount = data;
                            return billingAccount;
                        });
                } else {
                    return $q.when(billingAccount);
                }
            }

            function getStatementHistory(loginUserId) {
                if (loginUserId !== billingServiceUserId) {
                    resetBillingService();
                    setBillingServiceUserId(loginUserId);
                }

                if (!statementHistory) {
                    return BillingRepository.getStatementHistory(loginUserId)
                        .then(function (data) {
                            statementHistory = data;
                            return statementHistory;
                        });
                } else {
                    return $q.when(statementHistory);
                }
            }

            function setBillingServiceUserId(patientId) {
                billingServiceUserId = patientId;
            }

            function resetBillingService() {
                billingServiceUserId = null;
                billingAccount = null;
                accountBalance = null;
                statementHistory = null;
            }

            function getReceiptHtml(receiptRequestDto) {
                if (!receiptHtml || receiptRequestDto.TxId !== receiptHtml.TxId) {
                    return BillingRepository.getReceipt(receiptRequestDto)
                        .then(function (data) {
                            receiptHtml.TxId = receiptRequestDto.TxId;
                            receiptHtml.Result = data;
                            return receiptHtml.Result;
                        });
                } else {
                    return $q.when(receiptHtml.Result);
                }
            }

            return {
                getAccountBalance: getAccountBalance,
                getBillingAccount: getBillingAccount,
                getStatementHistory: getStatementHistory,
                getReceiptHtml: getReceiptHtml,
                getViewMakeAPaymentFeatureFlag: getViewMakeAPaymentFeatureFlag,
                getViewLedgerFeatureFlag: getViewLedgerFeatureFlag,
                getViewStatementFeatureFlag: getViewStatementFeatureFlag
            };
        }]);